module.exports = __webpack_public_path__ + "img/bunny.bcea33d3.png";